import { BookingHistoryCriteria } from '../models';

export class BookingHistoryLoad {
  public static readonly type = '[BookingHistory] Load';
  constructor(public payload: BookingHistoryCriteria) {}
}

export class BookingHistoryPreviewConfirmationPDF {
  public static readonly type = '[BookingHistory] Preview Confirmation PDF';
  constructor(public payload: BookingHistoryCriteria) {}
}

export class BookingHistoryDownloadConfirmationPDF {
  public static readonly type = '[BookingHistory] Download Confirmation PDF';
  constructor(public payload: BookingHistoryCriteria) {}
}

export class BookingHistoryInitialState {
  public static readonly type = '[BookingHistory] Set Initial State';
}
